const PATH = 'https://smsgw.vsc.mk:8080'

export default {
    PATH: PATH
}